import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
// removed legacy rxjs-compat operator import
import {PaginationInstance} from "ngx-pagination";
import {UserVerificationService} from "../services/user-verification.service";
import {KeycloakService} from "../services/keycloak.service";
import {ApiEndpoints} from "../services/api-endpoints";

declare var $: any;

@Component({ standalone: false, 
  selector: 'app-roaming-communities',
  templateUrl: './roaming-communities.component.html',
})
export class RoamingCommunitiesComponent implements OnInit, OnDestroy {

  private apiUrl = ApiEndpoints.GET_ALL_ROAMING_COMMUNITIES;

  isAdmin: boolean = false;
  username: string = KeycloakService.username;
  list: any[];
  p: number = 1;
  filterSearch: any;
  keywordSearch: any;

  public visible = false;
  public visibleAnimate = false;

  public show(): void {
    this.visible = true;
    setTimeout(() => this.visibleAnimate = true, 100);
  }

  public hide(): void {
    this.visibleAnimate = false;
    setTimeout(() => this.visible = false, 300);
  }

  public onContainerClicked(event: MouseEvent): void {
    if ((<HTMLElement>event.target).classList.contains('modal')) {
      this.hide();
    }
  }

  configPagerGetAllRoamingCommunities: PaginationInstance = {
    id: 'roaming-communities-list',
    currentPage: 1,
    itemsPerPage: 10,
  };

  constructor(private route: ActivatedRoute,
              private http: HttpClient,
              private router: Router,
              private userVerificationService: UserVerificationService) {
    this.route.params.subscribe(params => {
      this.filterSearch = params['filterSearch'];
      this.keywordSearch = params['keywordSearch'];
      if (this.filterSearch != "Search Type" || this.keywordSearch != null) {
        this.displayHeaderSearch(this.filterSearch, this.keywordSearch);
      }
    });

    this.isAdmin = this.userVerificationService.isAdmin;
    this.getServers();
    this.getData();
    this.displayHeaderSearch(this.filterSearch, this.keywordSearch);
  }

  getData() {
    var body: any = {"username": this.username};
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    let options =  {headers: headers};
    return this.http.post<any>(this.apiUrl, body, options);
  }

  getServers() {
    this.getData().subscribe(list => {
      this.list = list;
    })
  }

  displayHeaderSearch(filterSearch, keywordSearch) {
    if (filterSearch != "Search Type" && keywordSearch != "" && filterSearch && keywordSearch) {
      const headers = new HttpHeaders({'Content-Type': 'application/json'});
      let options =  {headers: headers};
      var url = ApiEndpoints.GET_ALL_ROAMING_COMMUNITIES;
      if (filterSearch == "name") {
        var body: any = {
          "username": this.username,
          "name": keywordSearch
        };
      }
      this.http.post<any>(url, body, options).subscribe(
          data => {
            this.list = data
          }
      );
    }
    if (filterSearch != "Search Type" && keywordSearch == "") {
      this.router.navigate(['/all-roaming-community']);
    }
  }

  ngAfterViewInit() {
    $("#menu0").addClass("collapse");
    $("#menu0").prev().addClass("collapsed");
    $("#menu1").addClass("collapse");
    $("#menu1").prev().addClass("collapsed");
    $("#menu2").addClass("collapse");
    $("#menu2").prev().addClass("collapsed");
    $("#menu3").removeClass("collapse");
    $("#menu3").prev().removeClass("collapsed");
  }

  ngOnInit() {
  }

  ngOnDestroy() {
  }

}
